import { BehaviorSubject } from 'rxjs';
import { CommonModalService } from './common-modal.service';
import * as i0 from "@angular/core";
import * as i1 from "./common-modal.service";
var AttributeFilterService = /** @class */ (function () {
    function AttributeFilterService(modalService) {
        this.modalService = modalService;
        this.attrFilters = new BehaviorSubject({
            filters: []
        });
        this.attrFilterColumns = new BehaviorSubject([]);
    }
    AttributeFilterService.prototype.clearAttrFilters = function (skipGetData) {
        this.attrFilters.next({
            filters: [],
            skipGetData: skipGetData
        });
    };
    AttributeFilterService.prototype.openAttrFilter = function (filterComponent) {
        this.modalService.openModalWindow(filterComponent, {
            height: '500px',
            width: '440px'
        });
    };
    AttributeFilterService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AttributeFilterService_Factory() { return new AttributeFilterService(i0.ɵɵinject(i1.CommonModalService)); }, token: AttributeFilterService, providedIn: "root" });
    return AttributeFilterService;
}());
export { AttributeFilterService };
